module.exports = __webpack_public_path__ + "img/logo-smb-login.47434c24.svg";